import script from "./VToggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./VToggle.vue?vue&type=script&lang=ts&setup=true"

import "./VToggle.vue?vue&type=style&index=0&id=0db02b4c&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db02b4c"]])

export default __exports__